import getAppName from '../getAppName';
export default function () {
    return getAppName() === 'kwai';
}
